import { OpenIdButton } from "metabase/auth/components/OpenIdButton";
import {
  PLUGIN_AUTH_PROVIDERS,
  PLUGIN_IS_PASSWORD_USER,
} from "metabase/plugins";
import MetabaseSettings from "metabase/utils/settings";

PLUGIN_AUTH_PROVIDERS.providers.push((providers) => {
  const openIdProvider = {
    name: "openid",
    Button: OpenIdButton,
  };

  return MetabaseSettings.get("openid-enabled")
    ? [...providers, openIdProvider]
    : providers;
});

PLUGIN_IS_PASSWORD_USER.push((user) => user.sso_source !== "oidc");
